import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("aloha_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const waLink = (settings, text) => {
  const number = (settings?.whatsapp || "306983400353").replace(/[^0-9]/g, "");
  const message = text || settings?.whatsapp_message || "Hello Aloha Corfu Tours! I would like information about your private tours in Corfu.";
  return `https://wa.me/${number}?text=${encodeURIComponent(message)}`;
};

export const formatApiError = (e) => {
  const detail = e?.response?.data?.detail;
  if (!detail) return e?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d.msg || JSON.stringify(d)).join(" ");
  return String(detail);
};
